import {LinkOptions} from "../types/Link";
import {useOperator} from "../context/OperatorContext";
import {OperatorSubdomain} from "../types/Operator";

type LinkOptionsEntity = 'link' | 'event' | 'exhibit'; // Add more entities when they are supported on the API

const operatorLinkOptions: Partial<Record<OperatorSubdomain, Partial<Record<LinkOptionsEntity, LinkOptions[]>>>> = {
  // Local
  dev: {
    link: [LinkOptions.AUTO_LOGIN],
    event: [LinkOptions.AUTO_LOGIN],
    exhibit: [LinkOptions.AUTO_LOGIN],
  },
  // Staging
  'test-operator': {
    link: [LinkOptions.AUTO_LOGIN],
    event: [LinkOptions.AUTO_LOGIN],
    exhibit: [LinkOptions.AUTO_LOGIN],
  },
  // Production
  lhp: {
    link: [LinkOptions.AUTO_LOGIN],
    event: [LinkOptions.AUTO_LOGIN],
    exhibit: [LinkOptions.AUTO_LOGIN],
  },
}

export function useLinkOptions(entity: LinkOptionsEntity, defaultOptions: LinkOptions[] = []) {
  const {subdomain} = useOperator();
  const operatorOptions: LinkOptions[] = subdomain ? operatorLinkOptions[subdomain]?.[entity] ?? [] : [];

  // Remove any duplicates by using a Set
  const linkOptionsSet = new Set([...operatorOptions, ...defaultOptions]);

  return Array.from(linkOptionsSet);
}